/**
 * Shared pricing plans — single source of truth.
 * Tier names MUST match subscription_limits.py keys exactly.
 * Active tiers: free_trial, Classic, Classic Pro, Enterprise Plus
 */

export const PLANS = [
  {
    id: 'free_trial',
    backendTier: 'free_trial',
    title: 'Free Trial',
    monthly: '$0',
    monthlyRaw: 0,
    annual: '$0',
    annualRaw: 0,
    description: 'Explore Avoices with no commitment. No credit card required.',
    popular: false,
    cta: 'Get Started Free',
    ctaPath: '/get-started',
    features: [
      { label: '2 audio uploads/mo', included: true },
      { label: '2 video uploads/mo', included: true },
      { label: '1 video dubbing/mo', included: true },
      { label: '2 voiceover renders/mo', included: true },
      { label: '2 text translations/mo', included: true },
      { label: '2 AI summarizations/mo', included: true },
      { label: '2 TTS conversions/mo', included: true },
      { label: '50+ languages', included: true },
      { label: 'API access', included: false },
      { label: 'Custom voice models', included: false },
    ],
  },
  {
    id: 'classic',
    backendTier: 'Classic',
    title: 'Classic',
    monthly: '$9',
    monthlyRaw: 9,
    annual: '$7',
    annualRaw: 7,
    description: 'For individuals and small teams getting started with voice AI.',
    popular: false,
    cta: 'Get Classic',
    ctaPath: '/dashboard/subscription',
    features: [
      { label: '10 audio uploads/mo', included: true },
      { label: '10 video uploads/mo', included: true },
      { label: '5 video dubbing/mo', included: true },
      { label: '20 voiceover renders/mo', included: true },
      { label: '50 text translations/mo', included: true },
      { label: '30 AI summarizations/mo', included: true },
      { label: '50 TTS conversions/mo', included: true },
      { label: '50+ languages', included: true },
      { label: 'API access', included: false },
      { label: 'Custom voice models', included: false },
    ],
  },
  {
    id: 'classic_pro',
    backendTier: 'Classic Pro',
    title: 'Classic Pro',
    monthly: '$29',
    monthlyRaw: 29,
    annual: '$23',
    annualRaw: 23,
    description: 'For growing teams shipping production-grade voice AI products.',
    popular: true,
    cta: 'Get Classic Pro',
    ctaPath: '/dashboard/subscription',
    features: [
      { label: '50 audio uploads/mo', included: true },
      { label: '50 video uploads/mo', included: true },
      { label: '30 video dubbing/mo', included: true },
      { label: '200 voiceover renders/mo', included: true },
      { label: '1,000 text translations/mo', included: true },
      { label: '600 AI summarizations/mo', included: true },
      { label: '1,000 TTS conversions/mo', included: true },
      { label: '50+ languages', included: true },
      { label: 'Full API access', included: true },
      { label: 'Custom voice models', included: false },
    ],
  },
  {
    id: 'enterprise_plus',
    backendTier: 'Enterprise Plus',
    title: 'Enterprise Plus',
    monthly: 'Custom',
    monthlyRaw: null,
    annual: 'Custom',
    annualRaw: null,
    description: 'Unlimited usage, custom models, and enterprise SLA for your team.',
    popular: false,
    cta: 'Contact Sales',
    ctaPath: 'mailto:phosaico@gmail.com?subject=Enterprise%20Plus%20Inquiry',
    features: [
      { label: 'Unlimited audio uploads', included: true },
      { label: 'Unlimited video uploads', included: true },
      { label: 'Unlimited video dubbing', included: true },
      { label: 'Unlimited voiceover renders', included: true },
      { label: 'Unlimited translations', included: true },
      { label: 'Unlimited AI summarizations', included: true },
      { label: 'Unlimited TTS conversions', included: true },
      { label: '50+ languages', included: true },
      { label: 'Full API + webhooks access', included: true },
      { label: 'Custom voice models', included: true },
    ],
  },
];

export const PLAN_COLORS = {
  'Free Trial':      '#64748b',
  'Classic':         '#10b981',
  'Classic Pro':     '#e89f28',
  'Enterprise Plus': '#C47F10',
};
